import { render, staticRenderFns } from "./r-plinko-game-config-panel.vue?vue&type=template&id=8343a1d0"
import script from "./r-plinko-game-config-panel.vue?vue&type=script&lang=js"
export * from "./r-plinko-game-config-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8343a1d0')) {
      api.createRecord('8343a1d0', component.options)
    } else {
      api.reload('8343a1d0', component.options)
    }
    module.hot.accept("./r-plinko-game-config-panel.vue?vue&type=template&id=8343a1d0", function () {
      api.rerender('8343a1d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-game-config-panel.vue"
export default component.exports